export default "__VITE_ASSET__6mrXEvhb__";